<script lang="ts">
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"

  type Props = {
    class?: string | null
    children?: Snippet
  }

  let { class: cssClass = undefined, children }: Props = $props()
</script>

<p class={cn("alert-body font-medium-400 text-general-default-text", cssClass)}>
  {@render children?.()}
</p>
